import { observable, action } from 'mobx';
import { provideSingleton } from '../utils/decorators';

interface IToastBase {
  message: string;
  details?: string;
}

interface IToastSuccess extends IToastBase {
  kind: 'success';
}

interface IToastError extends IToastBase {
  kind: 'error';
}

interface IToastInfo extends IToastBase {
  kind: 'info';
}

interface IToastWarning extends IToastBase {
  kind: 'warning';
}

export type IToast = IToastSuccess | IToastError | IToastInfo | IToastWarning;

@provideSingleton(ToastStore)
export class ToastStore {

  readonly notifications = observable<IToast>([]);

  @action show(notification: IToast) {
    this.notifications.push(notification);
  }

  @action hide(notification: IToast) {
    this.notifications.remove(notification);
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/ToastStore.ts